import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {Col, Row, ButtonToolbar, Button,} from 'reactstrap';
import TrashIcon from 'mdi-react/TrashOutlineIcon';
import { 
  fetchEventSocialWallImages, 
  deleteSocialWallImage, 
  fetchDefaultSocialWallImages
} from '@/shared/apiHelper';

const ListSocialWallImages = ({ icon, setIcon, onCancel, onSelectIconOK, defaultIcons, setDefaultIcons, icons, setIcons, program, setActiveTab, setIconUploadType }) => {

  const onclickGotoUploadIcon = (uploadTo = 'global') => {
    setIconUploadType(uploadTo)
    setActiveTab("1")
  }

  useEffect(() => {
    if (program?.organization_id) {
      fetchEventSocialWallImages(program.organization_id)
      .then(response => {
        setIcons(response)
      })
      fetchDefaultSocialWallImages(program.organization_id)
      .then(response => {
        setDefaultIcons(response)
      })
    }
  }, [program])

  const deleteIcon = async (icon) => {
    try {
      return deleteSocialWallImage(program.organization_id, icon);
    } catch (e) {
      throw new Error(`API error:${e?.message}`);
    }
  }

  const onClickDeleteIcon = (item) => {
    deleteIcon(item)
      .then(response => {
        if( icon.id === item.id)  { //if currently selected icon deleted
          setIcon(null) //reset state 
        }
        if (response.status === 200) {
          fetchEventSocialWallImages(program.organization_id)
            .then(response => {
              setIcons(response)
            })
        }
      })
  }

  const selectItem = (icon) => {
    setIcon(icon)
  }
  return (
    <Col md={12} lg={12}>
      <Row className='w100'>
        <h3>Choose from</h3>
        <Col md="12" className='mt-3 py-3'>
          <h4 className='title'>1. Global Library</h4>
          <ul className="img_wrap mt-2">
            {
              defaultIcons.map(function (item, key) {
                return <li key={key} onClick={(e) => selectItem(item)} className={icon?.id === item.id ? 'active' : ''}>
                  <div className='preview'>
                    <i className="fa fa-check"></i>
                    <img src={`${process.env.REACT_APP_API_STORAGE_URL}/${item.path}`} title={item.name} />
                  </div>
                </li>
              })
            }
            <li key={'uploadIconKey'}><Button outline color="primary" className="btn btn-xs" onClick={() => onclickGotoUploadIcon('global')}>+ Upload to Global Library</Button></li>
          </ul>
        </Col>
        <Col md="12" className='mt-3 my-3 text-center bggray'> - <strong>OR</strong> - </Col>
        <Col md="12" className='mt-3'>
          <h4>2. Program Library</h4>
          <ul className="img_wrap mt-2">
            {
              icons.map(function (item, key) {
                return <li key={key} onClick={(e) => selectItem(item)} className={icon?.id === item.id ? 'active' : ''}>
                  <div className='preview'>
                    <i className="fa fa-check"></i>
                    <img src={`${process.env.REACT_APP_API_STORAGE_URL}/${item.path}`} title={item.name} />
                    <div className="mt-2 delete-icon-icon" onClick={(e) => { if (window.confirm('Are you sure to delete this icon?')) { onClickDeleteIcon(item) } }}><TrashIcon color='#bdbdbd' /></div>
                  </div>
                </li>
              })
            }
            <li key={'uploadIconKey'}><Button outline color="primary" className="btn btn-xs" onClick={() => onclickGotoUploadIcon('program')}>+ Upload to Program Library</Button></li>
          </ul>
        </Col>
        <Col md="12" lg="12" xl="12" className='text-right'>
          <ButtonToolbar className="modal__footer flex justify-content-right w100">
            <Button outline color="primary" className="mr-3" onClick={onCancel}> Cancel </Button>{' '}
            <Button color="primary" disabled={!icon} className="mr-3" onClick={() => onSelectIconOK('social_wall_image', icon)} > OK </Button>{' '}
          </ButtonToolbar>
        </Col>
      </Row>
    </Col>
  )
}
ListSocialWallImages.propTypes = {
  icon: PropTypes.object.isRequired,
  setIcon: PropTypes.func.isRequired,
  setIcons: PropTypes.func.isRequired,
  onSelectIconOK: PropTypes.func.isRequired,
  icons: PropTypes.array.isRequired,
  onCancel: PropTypes.func.isRequired,
  program: PropTypes.object.isRequired,
};
export default ListSocialWallImages;